import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const PurpleDoorAgeJourney = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full mb-2 mt-2">
      <div className="border-y-2 border-dashed border-cyan-400 rounded-3xl bg-zinc-900/70 backdrop-blur-md p-5 animate-fadeIn">
        <div className="text-center mb-6">
          <h2 className="text-xl lg:text-3xl font-bold text-pink-300">
            🌱 PurpleDoor Life Journey
          </h2>

          <p className="mt-2 text-sm text-gray-400 max-w-3xl mx-auto">
            Empowering people throughout every stage of life while focusing on
            the most transformative years.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {/* Foundation */}
          <div className="rounded-2xl bg-slate-800/70 border border-slate-700 hover:border-cyan-400 transition-all duration-300 p-5">
            <div className="text-center text-5xl mb-3">🤰👶🧒</div>

            <h3 className="text-center text-cyan-300 font-bold text-lg">
              Foundation
            </h3>

            <p className="text-center text-xs text-gray-400 mb-5">
              🤰 Before Birth → 👶 0 – 18 Years
            </p>

            <ul className="space-y-2 text-sm text-gray-300">
              <li className="text-pink-300">🤰 Prenatal Care & Mother's Well-being</li>
              <li className="text-gray-100">📚 Learning</li>
              <li className="text-gray-100">🎨 Creativity</li>
              <li className="text-gray-100">💡 Curiosity</li>
              <li className="text-gray-100">🏫 Education</li>
              <li className="text-gray-100">🤝 Values & Character</li>
            </ul>
          </div>

          {/* Transformation Zone */}
          <div className="relative rounded-2xl bg-gradient-to-br from-fuchsia-600 via-pink-600 to-rose-500 text-white shadow-2xl scale-105 border-2 border-pink-300 p-6">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-yellow-300 text-black px-4 py-1 text-[11px] font-bold shadow">
              ⭐ PRIMARY FOCUS
            </div>

            <div className="text-center text-6xl mb-3 animate-pulse">💜</div>

            <h3 className="text-center text-xl font-bold">
              Transformation Zone
            </h3>

            <p className="text-center text-sm text-pink-100 mb-5">
              Age 18 – 35 Years
            </p>

            <ul className="space-y-2 text-sm">
              <li className="text-gray-100">🎓 Higher Education</li>
              <li className="text-gray-100">💼 Career & Employment</li>
              <li className="text-gray-100">🚀 Entrepreneurship</li>
              <li className="text-gray-100">🤖 AI & Digital Skills</li>
              <li className="text-gray-100">🎥 Create & Earn</li>
              <li className="text-gray-100">💰 Financial Independence</li>
              <li className="text-gray-100">❤️ Identity & Purpose</li>
              <li className="text-gray-100">🌍 Build Digital Legacy</li>
            </ul>
          </div>

          {/* Leadership */}
          <div className="rounded-2xl bg-slate-800/70 border border-slate-700 hover:border-emerald-400 transition-all duration-300 p-5">
            <div className="text-center text-5xl mb-3">👩👵🌳</div>

            <h3 className="text-center text-emerald-300 font-bold text-lg">
              Leadership & Legacy
            </h3>

            <p className="text-center text-xs text-gray-400 mb-5">
              Age 35 – 80+ Years
            </p>

            <ul className="space-y-2 text-sm text-gray-300">
              <li className="text-gray-100">🏢 Business Growth</li>
              <li className="text-gray-100">👨‍👩‍👧 Family Leadership</li>
              <li className="text-gray-100">🤝 Mentorship</li>
              <li className="text-gray-100">🌱 Community Building</li>
              <li className="text-gray-100">❤️ Social Contribution</li>
              <li className="text-gray-100">🌍 Lasting Legacy</li>
            </ul>
          </div>
        </div>

        {/* Bottom Quote */}
        <div className="mt-8 rounded-xl border border-pink-500/20 bg-gradient-to-r from-pink-500/10 to-purple-500/10 p-5">
          <h3 className="text-center text-lg font-bold text-pink-300">
            💜 PurpleDoor Philosophy
          </h3>

          <p className="mt-3 text-center text-sm text-gray-300 leading-relaxed max-w-4xl mx-auto">
            Every stage of life has a purpose. PurpleDoor supports lifelong
            growth while placing special emphasis on the transformational years
            between <span className="font-bold text-pink-300">18 and 35</span>,
            where education, careers, entrepreneurship, financial independence,
            meaningful relationships, and digital identity shape the future.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PurpleDoorAgeJourney;
